export default "__VITE_ASSET__DzDZV5Tm__"